import { render, staticRenderFns } from "./GuestsField.vue?vue&type=template&id=c80e1e38"
import script from "./GuestsField.vue?vue&type=script&lang=js"
export * from "./GuestsField.vue?vue&type=script&lang=js"
import style0 from "./GuestsField.vue?vue&type=style&index=0&id=c80e1e38&prod&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports